import { createStyles, makeStyles } from '@material-ui/styles';

const style = () =>
  createStyles({
    root: {
      display: 'flex',
      width: 'available',
      flexDirection: 'column'
    },
    default: {
      gap: '20px'
    },
    small: {
      gap: '10px'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
